export default __webpack_public_path__ + "static/media/Photo 7 - MR - Trappe désenfumage.04b21075.png";